import { useState } from "react";
import { PageLink, PageTitle } from "_metronic/layout/core";
import UserGroup from "./components/UserGroups";
import UserGroupMembers from "./components/UserGroupMembers";
import { Permission } from "services/userSession/UserPermittedComponent";
import { Permissions } from "cpl-react-common/components/Enums/Permissions";
import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "setup/appInsights/ApplicationInsightsService";

const userGroupsBreadCrumbs: Array<PageLink> = [
  {
    title: "User Groups",
    path: "/Admin/UserGroups",
    isSeparator: false,
    isActive: true,
  },
];
const UserGroupPage: React.FC = () => {
  const [userGroupID, updateUserGroupID] = useState<number | null>(null);

  function updateSelectedUserGroupID(selectedUserGroupID: number | null) {
    updateUserGroupID(selectedUserGroupID);
  }

  return (
    <Permission permissionPredicate={(permission) => permission === Permissions.ViewUserGroups}>
      <CPLAnalytics pageName="User Group Management">
        <PageTitle breadcrumbs={userGroupsBreadCrumbs}></PageTitle>
        <div className="row">
          <div className="col-sm-6">
            <UserGroup updateSelectedGroupID={updateSelectedUserGroupID}></UserGroup>
          </div>
          <div className="col-sm-6">
            <UserGroupMembers userGroupID={userGroupID}></UserGroupMembers>
          </div>
        </div>
      </CPLAnalytics>
    </Permission>
  );
};
export default withAITracking(reactPlugin, UserGroupPage, "User Group Management");
